module.exports = __webpack_public_path__ + "media/images/ui__arrowDown--dark-6dbc940550dd2a6e45fb1cb164f758b6.png";